import { AdminFinance } from "../../lib/apiTyped";
import { useResource } from "../../lib/useResource";
import { PageHeader } from "../../components/AppLayout";
import { DataTable, type Column } from "../../components/shared/DataTable";
import { Badge } from "../../components/shared/Card";
import { fmtTs } from "../../lib/format";

type Log = {
  id: string;
  actorUid: string;
  action: string;
  resourceId: string;
  timestamp?: unknown;
};

function actionColor(action: string): string {
  if (action.includes("REVOKED") || action.includes("DELETED") || action.includes("SUSPENDED") || action.includes("CANCELED")) return "#C61418";
  if (action.includes("CREATED") || action.includes("ACTIVATED") || action.includes("PAID")) return "#16A34A";
  return "#71717a";
}

export function AdminAudit() {
  const { data, loading } = useResource(() => AdminFinance.audit({ pageSize: 100 }), []);

  const columns: Column<Log>[] = [
    {
      header: "Action",
      render: (r) => <Badge label={r.action} color={actionColor(r.action)} />,
    },
    {
      header: "Resource",
      render: (r) => <code className="text-xs text-ink-2">{r.resourceId}</code>,
    },
    {
      header: "Actor",
      render: (r) => <code className="text-xs text-ink-3">{r.actorUid}</code>,
    },
    { header: "When", render: (r) => fmtTs(r.timestamp) },
  ];

  return (
    <>
      <PageHeader title="Audit logs" subtitle="Every admin and webhook action, immutable." />
      <DataTable
        rows={(data?.logs ?? null) as Log[] | null}
        loading={loading}
        rowKey={(r) => r.id}
        columns={columns}
        empty={{ title: "No log entries yet" }}
      />
    </>
  );
}
